export const rateCenterPath = "/dids/logistics/rate-center"
